import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card mb-5 mb-xl-10" }
const _hoisted_3 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_4 = { class: "card-body border-top p-9" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Edit Subscription"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, " Manajemen Customer dan Harga ")
], -1)
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Customer", -1)
const _hoisted_9 = { class: "col-lg-12" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, " Subscription Plan ", -1)
const _hoisted_11 = { class: "col-lg-6" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, " Fitur active date ", -1)
const _hoisted_13 = { class: "col-lg-6" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, " Fitur end date ", -1)
const _hoisted_15 = {
  key: 0,
  class: "col-lg-12"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, " Start invoice date ", -1)
const _hoisted_17 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Simpan ", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Silahkan Tunggu ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" })
], -1)
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]

import ApiService from "@/core/services/ApiService";
import { onBeforeMount, ref, onMounted } from "vue";
import Multiselect from "@vueform/multiselect";
import CardPlan from "@/components/cards/CardPlanSelect.vue";
import { Field, Form } from "vee-validate";
import moment from "moment";
import Loading from "vue-loading-overlay";
import { useRoute, useRouter } from "vue-router";
import { useToast } from "vue-toastification";
import "vue-loading-overlay/dist/vue-loading.css";

export default /*#__PURE__*/_defineComponent({
  props: {
  widgetClasses: String,
},
  setup(__props) {



const ListSchool = ref([]);
const loadingComboSchool = ref(false);
const timerComboSchool = ref(0);
const isLoading = ref(false);
const fullPage = ref(true);
const isColor = "#007BFF";
const isBackgroundColor = "#A3A3A3";
const isOpacity = 0.5;

const customers = ref({});

const data = ref({
  isDelete: false,
  customer_id: "",
  customer_name: "",
  pricing_plan_id: "",
  start_date: "",
  end_date: "",
  start_invoice_date: "",
  is_active: true,
});

const router = useRouter();
const route = useRoute();
const toast = useToast();

const getListSchool = (name = "") => {
  loadingComboSchool.value = true;

  ApiService.getWithoutSlug(
    `crmv2/main_invoice/invoice/office/invoice/combo/school?name=${name}`
  ).then(({ data }) => {
    loadingComboSchool.value = false;
    ListSchool.value = data.map((d) => {
      return { label: d.name, value: d.id };
    });
  });
};

const getData = () => {
  isLoading.value = true;
  const id = route.params._id;

  ApiService.getWithoutSlug("crmv2/main_feature/subscriptions/" + id)
    .then((res) => {
      res.data.data.start_invoice_date =
        res.data.data.start_invoice_date.split("T")[0];
      res.data.data.start_date = res.data.data.start_date.split("T")[0];
      res.data.data.end_date = res.data.data.end_date.split("T")[0];
      if (res.data.data.customer_id && res.data.data.customer_name)
        customers.value = {
          label: res.data.data.customer_name,
          value: res.data.data.customer_id,
        };
      data.value = res.data.data;
    })
    .catch((error) => {
      console.log(error);
    })
    .finally(() => {
      isLoading.value = false;
    });
};

const cari = (val) => {
  clearTimeout(timerComboSchool.value); //this timer 0 - set 0 atau clear jika ada input lagi
  loadingComboSchool.value = true;
  timerComboSchool.value = setTimeout(() => {
    getListSchool(val);
  }, 1000);
};

const handleSubmit = () => {
  isLoading.value = true;
  data.value.start_date = moment(data.value.start_date)
    .set({
      hour: moment().hour(),
      minute: moment().minute(),
      second: moment().second(),
      millisecond: moment().millisecond(),
    })
    .toISOString();
  data.value.end_date = moment(data.value.end_date)
    .set({
      hour: moment().hour(),
      minute: moment().minute(),
      second: moment().second(),
      millisecond: moment().millisecond(),
    })
    .toISOString();
  data.value.start_invoice_date = moment(data.value.start_invoice_date)
    .set({
      hour: moment().hour(),
      minute: moment().minute(),
      second: moment().second(),
      millisecond: moment().millisecond(),
    })
    .toISOString();

  data.value.customer_id = customers.value.value;
  data.value.customer_name = customers.value.label;
  try {
    ApiService.putWithData(
      `/crmv2/main_feature/subscriptions/${route.params._id}`,
      data.value
    );
    toast.success("Data berhasil disimpan");
    router.push("/superadmin/master-feature/subscription");
  } catch (error) {
    toast.error("Something went wrong");
    console.log(error);
  } finally {
    isLoading.value = false;
  }
};

onMounted(() => {
  getData();
});

onBeforeMount(() => {
  getListSchool();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(Loading), {
        active: isLoading.value,
        "is-full-page": fullPage.value,
        color: isColor,
        "background-color": isBackgroundColor,
        opacity: isOpacity
      }, null, 8, ["active", "is-full-page"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(Form), {
          id: "kt_account_profile_details_form",
          class: "form",
          novalidate: "novalidate",
          onSubmit: handleSubmit
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_unref(Multiselect), {
                    modelValue: customers.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((customers).value = $event)),
                    placeholder: "Select Customer",
                    mode: "single",
                    options: ListSchool.value,
                    searchable: true,
                    object: true,
                    onSearchChange: cari,
                    loading: loadingComboSchool.value
                  }, null, 8, ["modelValue", "options", "loading"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  (data.value.pricing_plan_id)
                    ? (_openBlock(), _createBlock(CardPlan, {
                        key: 0,
                        modelValue: data.value.pricing_plan_id,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.value.pricing_plan_id) = $event))
                      }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(_unref(Field), {
                    type: "date",
                    name: "activatedDate",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Tanggal Mulai",
                    modelValue: data.value.start_date,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.value.start_date) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode(_unref(Field), {
                    type: "date",
                    name: "endFeatureDate",
                    class: "form-control form-control-lg",
                    placeholder: "Isi Tanggal Mulai",
                    modelValue: data.value.end_date,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((data.value.end_date) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                (data.value.start_invoice_date !== '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _hoisted_16,
                      _createVNode(_unref(Field), {
                        type: "date",
                        name: "startInvoiceDate",
                        class: "form-control form-control-lg",
                        placeholder: "Isi Tanggal Mulai",
                        modelValue: data.value.start_invoice_date,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((data.value.start_invoice_date) = $event))
                      }, null, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-danger me-3",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push('/superadmin/master-feature/subscription')))
                }, " Batal "),
                _createElementVNode("button", {
                  type: "submit",
                  id: "kt_account_profile_details_submit",
                  ref: (_value, _refs) => {
                    _refs['submitButton'] = _value
                  },
                  class: "btn btn-primary"
                }, _hoisted_20, 512)
              ])
            ])
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})